import { render, staticRenderFns } from "./PointOrderWriteOff.vue?vue&type=template&id=c34b04d0&scoped=true&"
import script from "./PointOrderWriteOff.vue?vue&type=script&lang=js&"
export * from "./PointOrderWriteOff.vue?vue&type=script&lang=js&"
import style0 from "./PointOrderWriteOff.vue?vue&type=style&index=0&id=c34b04d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34b04d0",
  null
  
)

export default component.exports